import { isNil, omitBy } from 'lodash-es';

import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v3/search/id/`;

export const QueryKey = (payload?: Payload) => ['v3', 'search', 'id', omitBy(payload, isNil)] as const;

export type Payload = {
    id: string[];
    references?: boolean;
    referenceFields?: string[];
};

export type Response = {
    documents: Record<string, Models.Search.Source>;
    references: Record<string, Models.Search.Source>;
};
